import CompleteTransfer from "@components/complete-transfer/CompleteTransfer";
import Layout from "@components/layout";
import { getGlobals } from "@models/globals.model";
import { Sanity } from "@models/sanity.model";
import { NextPage } from "next";

const CompleteTransferPage: NextPage<Sanity.PageProps> = ({ globals }) => {
  return (
    <Layout globals={globals} pageID="complete-transfer" seo={{ title: "Account Transfer" }}>
      <CompleteTransfer />
    </Layout>
  );
};

export default CompleteTransferPage;

export async function getStaticProps() {
  const [globals] = await Promise.all([await getGlobals()]);

  return {
    props: {
      globals,
    },
  };
}
